import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import ButtonApp from "@/components/ButtonApp.vue";
import IconSvg from "@/components/IconSvg.vue";
import vCLickOutside from "v-click-outside";
import { uiMapper } from "@/services/store/modules/ui/store";
import { dataMapper } from "@/services/store/modules/data/store";
import includeScriptOnce from "@/mixins/includeScriptOnce";
const UiMappers = Vue.extend({
    methods: {
        ...uiMapper.mapMutations(["closeFormPay"]),
    },
});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["formCall", "courses"]),
        ...dataMapper.mapGetters(["formName", "formPhone"]),
    },
    methods: {
        ...dataMapper.mapMutations(["clearForm"]),
        ...dataMapper.mapActions(["sendForm", "updateFormField"]),
    },
});
let FormPay = class FormPay extends Mixins(UiMappers, DataMappers) {
    constructor() {
        super(...arguments);
        this.courseSelectIsShown = false;
        this.activeTitle = null;
        this.formType = "callback";
        this.activeCourseInput = null;
        this.activeSum = null;
    }
    get activeIdParam() {
        return this.$route.params && this.$route.params.id;
    }
    get coursesTitles() {
        return [...this.courses.map((c) => c.title), "Другое"];
    }
    get activeCourseIndex() {
        return this.coursesTitles.indexOf(this.activeTitle);
    }
    get activeCourse() {
        if (this.activeCourseIndex === this.coursesTitles.length - 1)
            return null;
        else
            return this.courses.find((c) => c.title === this.activeTitle);
    }
    // get activeSum() {
    //   return this.activeCourse && this.activeCourse.priceNumber
    // }
    // set activeSum(value) {
    //   this.activeSum = value
    // }
    async created() {
        await includeScriptOnce("https://securepay.tinkoff.ru/html/payForm/js/tinkoff_v2.js");
        // this.setActiveCourse()
    }
    setActiveCourse() {
        if (this.activeIdParam)
            this.activeTitle = this.courses.find((c) => Number(c.id) === Number(this.activeIdParam)).title;
        else
            this.activeTitle = this.coursesTitles[0];
        this.activeCourseInput = this.activeTitle;
        this.activeSum = this.activeCourse && this.activeCourse.priceNumber;
    }
    updateCourseValue(value) {
        this.activeTitle = value;
        if (!!this.activeCourse) {
            this.activeCourseInput = this.activeTitle.replace(/&nbsp;/gi, " ");
            this.activeSum = this.activeCourse && this.activeCourse.priceNumber;
        }
        else {
            this.activeCourseInput = null;
            this.activeSum = null;
        }
    }
    toggleCourseSelect() {
        this.courseSelectIsShown = !this.courseSelectIsShown;
    }
    closeCourseSelect() {
        this.courseSelectIsShown = false;
    }
    onCloseClick() {
        this.closeFormPay();
    }
    onFirstBtnClick() {
        this.$emit("firstBtnClicked");
    }
    onSecondBtnClick() {
        this.$emit("secondBtnClicked");
    }
    onClickOutside(evt) {
        const targetIsModal = evt.srcElement.classList.contains("modal-pay");
        if (targetIsModal)
            this.closeFormPay();
    }
};
FormPay = __decorate([
    Component({
        directives: {
            clickOutside: vCLickOutside.directive,
        },
        components: {
            ButtonApp,
            IconSvg,
        },
    })
], FormPay);
export default FormPay;
